import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalDialogType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { PosCreditRequestCompanyContactInformationModalService } from 'src/app/@core/services/pos-credit-request-company-contact-information-modal.service';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import { ColumnTable } from 'src/app/models/column-table';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { Paging } from 'src/app/models/page';
import { ContactTable } from 'src/app/models/table-models/contact-table';
import { OnbaseService } from 'src/app/services/onbase.service';

@Component({
  selector: 'pos-company-contact-information-step',
  templateUrl: './company-contact-information-step.component.html',
  styleUrls: ['./company-contact-information-step.component.sass']
})
export class CompanyContactInformationStepComponent implements OnInit {

  constructor(private companyModal: PosCreditRequestCompanyContactInformationModalService, private confirmService: PosConfirmationService, private onbaseService: OnbaseService) { }

  @Input() companyContactInformationForm: FormArray = new FormArray([]);
  @Input() disabled = false;
  @Input() isEdit = false;
  @Input() onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  contactPositions: Array<{ key: string, value: string }> = [];
  contactTable: Paging<Array<ContactTable>> = new Paging([]);
  async ngOnInit(): Promise<void> {
    this.companyContactInformationForm.valueChanges.subscribe(async s => {
      if (this.onbaseCatalogue.economicActivity.length == 0) {
        this.onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
      }
      this.contactPositions = ObjectUtils.objectToArray(this.onbaseCatalogue.businessPosition);
      if (this.isEdit) {
        this.contactTable = new Paging([]);
        (s as Array<any>).forEach((f, i) => {
          this.contactTable.content.push({
            code: i,
            contactPosition: this.contactPositions.find(s => s.key == f.contactPosition)?.value || f.contactPosition,
            fullName: `${f.firstName} ${f.middleName} ${f.lastName} ${f.secondLastName}`,
            phone: f.phone,
            status: this.companyContactInformationForm.at(i).valid
          });


        })
        this.contactTable = new Paging(this.contactTable.content);

      }
    });
  }

  getContactTableHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable("contactPosition", "Cargo"),
      new ColumnTable("fullName", "Nombre"),
      new ColumnTable("phone", "Teléfono"),
      new ColumnTable("status", "Estado", { type: "hidden" }),
      new ColumnTable("code", "Opciones", {
        type: "action", actions: [
          {
            fn: async (row: ContactTable) => {
              let formGroup = this.companyContactInformationForm.at(row.code) as FormGroup;
              await this.companyModal.show(formGroup,
                (f: FormGroup) => {
                  this.companyContactInformationForm.removeAt(row.code);
                  this.companyContactInformationForm.insert(row.code, f);
                  this.updateTable(f, row.code);
                });
            },
            icon: "fa fa-pencil",
            isDisabled: false,
            tooltip: "Editar",
            disabledFn: () => { return this.disabled; }
          },
          {
            fn: async (row: ContactTable) => {
              const result = await this.confirmService.showAsync("Advertencia", "¿Está seguro de eliminar el registro?", ModalDialogType.WARNING);
              if (result) {
                this.companyContactInformationForm.removeAt(row.code);
                this.deleteFromTable(row.code);
              }
            },
            icon: "fa fa-trash",
            isDisabled: false,
            tooltip: "Delete",
            disabledFn: () => { return this.disabled; }
          }
        ]
      }),
    ];
  }

  async addContact() {
    await this.companyModal.show(this.configureNewForm(), (f: FormGroup) => {
      this.companyContactInformationForm.push(f);
      this.companyContactInformationForm.markAsDirty();
      if (!this.isEdit) {
        this.updateTable(f);
      }
    });
  }

  private updateTable(f: FormGroup, code?: number) {

    let contact = new ContactTable();
    if (code != undefined) {
      contact = this.contactTable.content.find(f => f.code == code) || new ContactTable();
    }
    contact.fullName = `${f.value.firstName} ${f.value.middleName} ${f.value.lastName} ${f.value.secondLastName}`;
    contact.phone = f.value.phone;
    contact.contactPosition = this.contactPositions.find(s => s.key == f.value.contactPosition)?.value || f.value.contactPosition;
    contact.status = f.valid;

    if (code == undefined) {
      this.contactTable.content.push(contact);
    }

    this.updateCodes(this.contactTable.content);
    this.contactTable = new Paging(this.contactTable.content);
  }

  private deleteFromTable(code: number) {
    this.contactTable.content = this.contactTable.content.filter(f => f.code != code);
    this.updateCodes(this.contactTable.content);
    this.contactTable = new Paging(this.contactTable.content);
  }
  configureNewForm() {
    let form = new FormGroup({
      firstName: new FormControl("", Validators.required),
      middleName: new FormControl(""),
      lastName: new FormControl("", Validators.required),
      secondLastName: new FormControl(""),
      contactPosition: new FormControl("", Validators.required),
      mobilePhone: new FormControl("", Validators.required),
      phone: new FormControl("", Validators.required),
      phoneExtension: new FormControl(""),
      email: new FormControl("", [Validators.required, Validators.email]),
    });

    form.get("contactPosition")?.markAsDirty()
    return form;
  }
  private updateCodes(content: ContactTable[]) {
    content.forEach((f, i) => f.code = i);
  }
}



